webpackJsonp([35783957827783],{

/***/ 42:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 243:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact(props) {
	  return _react2.default.createElement(
	    'section',
	    { id: 'contact' },
	    _react2.default.createElement(
	      'div',
	      { id: 'title' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Get in Touch'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'description' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'We are currently available for contract work'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'actionable' },
	      _react2.default.createElement(
	        'a',
	        {
	          href: 'mailto:' + props.email,
	          target: '_top',
	          className: 'btn btn-outline-primary'
	        },
	        props.email
	      )
	    )
	  );
	};
	
	Contact.defaultProps = {
	  email: 'contact@starkissstudios.com'
	};
	
	Contact.propTypes = {
	  email: _propTypes2.default.string
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Star.c4e08adf.png";

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(245);
	
	var _Star = __webpack_require__(277);
	
	var _Star2 = _interopRequireDefault(_Star);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hero = function (_React$PureComponent) {
	  _inherits(Hero, _React$PureComponent);
	
	  function Hero() {
	    _classCallCheck(this, Hero);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Hero.prototype.renderHeroImage = function renderHeroImage() {
	    return _react2.default.createElement(
	      'section',
	      { id: 'imagery' },
	      _react2.default.createElement('div', { id: 'background' }),
	      _react2.default.createElement('div', { id: 'boi' }),
	      _react2.default.createElement('div', { id: 'logo-bg' }),
	      _react2.default.createElement(
	        'div',
	        { id: 'spin-star' },
	        _react2.default.createElement('img', { src: _Star2.default, alt: '' })
	      ),
	      _react2.default.createElement('div', { id: 'logo', title: 'StarKiss Studios' })
	    );
	  };
	
	  Hero.prototype.renderAbout = function renderAbout() {
	    return _react2.default.createElement(
	      'section',
	      { id: 'about' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'We are a small software development company specializing in creating highly functional and beautiful apps and websites.'
	      )
	    );
	  };
	
	  Hero.prototype.render = function render() {
	    return _react2.default.createElement(
	      'header',
	      { id: 'hero' },
	      this.renderHeroImage(),
	      this.renderAbout()
	    );
	  };
	
	  return Hero;
	}(_react2.default.PureComponent);
	
	/*
	 * If you have an
	 * idea that you want realized, don’t hesitate in contacting us.
	 */
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Media = function (_React$PureComponent) {
	  _inherits(Media, _React$PureComponent);
	
	  function Media() {
	    _classCallCheck(this, Media);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Media.prototype.getTitle = function getTitle(title) {
	    if (title.length === 1) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'title' },
	        _react2.default.createElement(
	          'span',
	          null,
	          title[0]
	        )
	      );
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'title secondary' },
	      _react2.default.createElement(
	        'span',
	        null,
	        title[0]
	      ),
	      _react2.default.createElement('br', { className: 'break' }),
	      _react2.default.createElement(
	        'span',
	        { className: 'space' },
	        '\xA0'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'offset' },
	        title[1]
	      )
	    );
	  };
	
	  Media.prototype.renderContent = function renderContent() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      'NOT IMPLEMENTED'
	    );
	  };
	
	  Media.prototype.render = function render() {
	    return this.renderContent();
	  };
	
	  return Media;
	}(_react2.default.PureComponent);
	
	exports.default = Media;
	module.exports = exports['default'];

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Mobile-Apps.9b259870.png";

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(44);
	
	var _2 = _interopRequireDefault(_);
	
	__webpack_require__(247);
	
	var _MobileApps = __webpack_require__(278);
	
	var _MobileApps2 = _interopRequireDefault(_MobileApps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MobileApp = function (_Media) {
	  _inherits(MobileApp, _Media);
	
	  function MobileApp() {
	    _classCallCheck(this, MobileApp);
	
	    return _possibleConstructorReturn(this, _Media.apply(this, arguments));
	  }
	
	  MobileApp.prototype.renderContent = function renderContent() {
	    var item = this.props.item;
	
	    return _react2.default.createElement(
	      'section',
	      { id: 'mobile-app', className: 'media-item star-bg' },
	      _react2.default.createElement('div', { id: 'spacer' }),
	      _react2.default.createElement(
	        'div',
	        { id: 'title' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Mobile Apps'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'imagery' },
	        _react2.default.createElement(
	          'div',
	          { id: 'bg' },
	          _react2.default.createElement('img', { src: _MobileApps2.default, alt: '' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'media-content' },
	        _react2.default.createElement(
	          'p',
	          null,
	          item.description
	        )
	      )
	    );
	  };
	
	  return MobileApp;
	}(_2.default);
	
	exports.default = MobileApp;
	module.exports = exports['default'];

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WebApp-1.7b21b1e4.png";

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WebApp-2.6792f7f8.png";

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WebApp-3.3a8c0a89.png";

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(44);
	
	var _2 = _interopRequireDefault(_);
	
	__webpack_require__(248);
	
	var _WebApp = __webpack_require__(279);
	
	var _WebApp2 = _interopRequireDefault(_WebApp);
	
	var _WebApp3 = __webpack_require__(280);
	
	var _WebApp4 = _interopRequireDefault(_WebApp3);
	
	var _WebApp5 = __webpack_require__(281);
	
	var _WebApp6 = _interopRequireDefault(_WebApp5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WebApp = function (_Media) {
	  _inherits(WebApp, _Media);
	
	  function WebApp() {
	    _classCallCheck(this, WebApp);
	
	    return _possibleConstructorReturn(this, _Media.apply(this, arguments));
	  }
	
	  WebApp.prototype.renderImages = function renderImages() {
	    return _react2.default.createElement(
	      'div',
	      { id: 'apps' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { src: _WebApp2.default, alt: 'Cownter Web App' })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { src: _WebApp4.default, alt: 'Lighthouse Web App' })
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { src: _WebApp6.default, alt: 'RasBrewy Pi Web App' })
	      )
	    );
	  };
	
	  WebApp.prototype.renderContent = function renderContent() {
	    var item = this.props.item;
	
	    return _react2.default.createElement(
	      'section',
	      { id: 'web-app', className: 'media-item' },
	      _react2.default.createElement(
	        'div',
	        { id: 'title' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Web Apps'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'imagery' },
	        this.renderImages()
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'media-content' },
	        _react2.default.createElement(
	          'p',
	          null,
	          item.description
	        )
	      )
	    );
	  };
	
	  return WebApp;
	}(_2.default);
	
	exports.default = WebApp;
	module.exports = exports['default'];

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Website-Devices.a68c06dc.png";

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(44);
	
	var _2 = _interopRequireDefault(_);
	
	__webpack_require__(249);
	
	var _WebsiteDevices = __webpack_require__(282);
	
	var _WebsiteDevices2 = _interopRequireDefault(_WebsiteDevices);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Website = function (_Media) {
	  _inherits(Website, _Media);
	
	  function Website() {
	    _classCallCheck(this, Website);
	
	    return _possibleConstructorReturn(this, _Media.apply(this, arguments));
	  }
	
	  Website.prototype.renderText = function renderText() {
	    var item = this.props.item;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'media-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'description' },
	        item.description
	      )
	    );
	  };
	
	  Website.prototype.renderImages = function renderImages() {
	    return _react2.default.createElement(
	      'div',
	      { id: 'devices' },
	      _react2.default.createElement('img', {
	        src: _WebsiteDevices2.default,
	        alt: 'Frontier Geomatics Inc\'s website on a phone, tablet, and PC'
	      })
	    );
	  };
	
	  Website.prototype.renderContent = function renderContent() {
	    var item = this.props.item;
	
	    return _react2.default.createElement(
	      'section',
	      { id: 'website', className: 'media-item star-bg' },
	      _react2.default.createElement(
	        'div',
	        { id: 'title' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Websites'
	        )
	      ),
	      _react2.default.createElement('div', { id: 'spacer' }),
	      _react2.default.createElement(
	        'div',
	        { id: 'imagery' },
	        this.renderImages()
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'media-content' },
	        _react2.default.createElement(
	          'p',
	          null,
	          item.description
	        )
	      )
	    );
	  };
	
	  return Website;
	}(_2.default);
	
	exports.default = Website;
	module.exports = exports['default'];

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobileApp = __webpack_require__(135);
	
	var _mobileApp2 = _interopRequireDefault(_mobileApp);
	
	var _webApp = __webpack_require__(136);
	
	var _webApp2 = _interopRequireDefault(_webApp);
	
	var _website = __webpack_require__(137);
	
	var _website2 = _interopRequireDefault(_website);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ServiceListing = function (_React$PureComponent) {
	  _inherits(ServiceListing, _React$PureComponent);
	
	  function ServiceListing() {
	    _classCallCheck(this, ServiceListing);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  ServiceListing.prototype.render = function render() {
	    var items = this.props.items;
	
	    return _react2.default.createElement(
	      'section',
	      { id: 'services' },
	      _react2.default.createElement(_mobileApp2.default, { key: '1', item: items[0] }),
	      _react2.default.createElement(_webApp2.default, { key: '2', item: items[1] }),
	      _react2.default.createElement(_website2.default, { key: '3', item: items[2] })
	    );
	  };
	
	  return ServiceListing;
	}(_react2.default.PureComponent);
	
	var media1 = {
	  description: 'We create dedicated native apps for each platform. Apps that look and feel tailored made for the platform while keeping a consistent look between platforms.'
	};
	
	var media2 = {
	  title: ['Web Apps'],
	  description: 'Either as a standalone app or combined with mobile apps, we make web apps that are easy to use and work on all devices.'
	};
	
	var media3 = {
	  title: ['Websites'],
	  description: 'Beautifully responsive design that looks good on all devices regardless of size and platform. Our website designs will make your brand stand out of the crowd.'
	};
	
	ServiceListing.defaultProps = {
	  items: [media1, media2, media3]
	};
	
	exports.default = ServiceListing;
	module.exports = exports['default'];

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hero = __webpack_require__(134);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _serviceListing = __webpack_require__(138);
	
	var _serviceListing2 = _interopRequireDefault(_serviceListing);
	
	var _contact = __webpack_require__(132);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'main',
	    { id: 'main-content', className: 'container-fluid' },
	    _react2.default.createElement(_hero2.default, null),
	    _react2.default.createElement(_serviceListing2.default, null),
	    _react2.default.createElement(_contact2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f62bca944de22572dc11.js